import { getDate, isofy } from 'utilities/date-time'
import { subMonths, startOfDay, endOfDay } from 'date-fns'

export const getDateRangeDefault = () => [getDate(subMonths(new Date(), 1)), getDate()]

export const adaptParams = ({ dateRange, ...filter }) => {
    let [
        from,
        to
    ] = dateRange ?? []

    if(from) {
        from = isofy(from)
        from = (from instanceof Date) ?
            startOfDay(from)?.toISOString() :
            null
    }

    if(to) {
        to = isofy(to)
        to = (to instanceof Date) ?
            endOfDay(to)?.toISOString() :
            null
    }

    return {
        ...filter,
        from,
        to
    }
}